import styled, { css } from 'styled-components';

import { centeredGridColumns, getGridBase } from '@utils/styled';
import { media } from '@utils/mediaQueries';

export const GridWrapper = styled.div`
  ${getGridBase()};
  margin: 0 auto;
`;

export const Grid = styled.div`
  grid-column: ${centeredGridColumns(12)};
  max-width: 100%;
  ${({ theme, spacingTop }) =>
    spacingTop && theme.getFluidSpacing('margin-top', ...spacingTop)};
  ${({ theme, spacingBottom }) =>
    spacingBottom && theme.getFluidSpacing('margin-bottom', ...spacingBottom)};

  ${media.from640up(css`
    grid-column: ${centeredGridColumns(10)};
  `)};

  ${media.from1200up(css`
    grid-column: ${centeredGridColumns(8)};
  `)};
`;
